export default __webpack_public_path__ + "static/media/ai_banner_human.b6f031c1.png";